import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppHotelService } from 'src/app/provider/app-hotel.service';
import { AppHotelModel } from 'src/app/views/models/app-hotel.model';
import { RequestLineModel } from 'src/app/views/models/request-line.model';

@Component({
  selector: 'kt-redeem-popup',
  templateUrl: './redeem-popup.component.html',
  styleUrls: ['./redeem-popup.component.scss']
})
export class RedeemPopupComponent implements OnInit {

  @Input() popupVisibleRedeem = false;
  @Input() currentRequestRedeem: RequestLineModel;
  @Output() sendPopupVisibleRedeem = new EventEmitter<string>();

  currentHotelInfo: AppHotelModel;

  is_processing = new BehaviorSubject<boolean>(false);
  quest_mark = new BehaviorSubject<boolean>(true);
  completed = new BehaviorSubject<boolean>(false);



  constructor(private appHotel: AppHotelService) {

    this.appHotel.getHotelInfo(+localStorage.getItem('hotelId')).subscribe(
      (hotelInfo: AppHotelModel) => {
        this.currentHotelInfo = hotelInfo;
      }
    );
  }

  ngOnInit() {
  }

  completeRedeem(id: string) {
    console.log("completeRedeem")
    this.is_processing.next(true);
    this.quest_mark.next(false);
    setTimeout(() => {
      this.completed.next(true);
      this.is_processing.next(false);
    }, 3000)

  }

  close() {
    this.sendPopupVisibleRedeem.emit("false");
  }

}
